import { ExchangeRateSourceType } from '@/app/constants/configuration/exchangeRateSourceType'
import React from 'react'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { faDownloadRegular } from '@/lib/fa'
import { Button } from '@/ui'
import { getEmptyMessage } from '../utils'

type Props = {
  exchangeRateDate: string
  sourceType: ExchangeRateSourceType
  handleDownloadExchangeRates: () => void
  isFutureDate?: boolean
}

export const EmptyScreen = ({
  exchangeRateDate,
  sourceType,
  handleDownloadExchangeRates,
  isFutureDate = false,
}: Props) => {
  const { t } = useLocalize()
  const text = getEmptyMessage(sourceType, t, exchangeRateDate)

  return (
    <div className="tw-flex tw-min-h-[320px] tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-p-5">
      <span className="tw-text-lg tw-font-bold">{text}</span>

      {(sourceType == ExchangeRateSourceType.Nbp ||
        sourceType == ExchangeRateSourceType.Ecb) && (
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4">
          <Button
            text={t('newDelegation.download-exchange-rate')}
            faLeadingIcon={faDownloadRegular}
            onClick={handleDownloadExchangeRates}
            disabled={isFutureDate}
          />
          {isFutureDate && (
            <span className="tw-text-sm tw-text-content-base/70">
              Nie można pobrać kursów dla daty z przyszłości.
            </span>
          )}
        </div>
      )}
    </div>
  )
}
